var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-left"},[_c('b-form-select',{staticClass:"form-control",attrs:{"options":this.getCharges},model:{value:(_vm.nuevoCargoId),callback:function ($$v) {_vm.nuevoCargoId=$$v},expression:"nuevoCargoId"}},[_c('b-form-select-option',{attrs:{"value":null}},[_vm._v("Cargo")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }